import {Injectable} from '@angular/core';
import {TrendsResponse} from '@npck/af-frontend-api';
import {RouterService} from '@npck/libs/commons';
import dayjs from 'dayjs';
import {initialTableEvent, TableEvent} from '../components/full-table/full-table.component';
import {Path} from '../path';

@Injectable({providedIn: 'root'})
export class TrendsFilterHolderService {
    private tableHolder = this.initialState();

    constructor(
        private routerService: RouterService,
    ) {
        this.routerService.navigationEnd()
            .subscribe(event => {
                if (!event.url.includes(Path.ANALYTICS)) {
                    this.clear();
                }
            });
    }

    storeTableState(tableEvent: TableEvent): TrendsTableInfo {
        this.tableHolder = {...this.tableHolder, tableEvent};
        return this.tableHolder;
    }

    storeResponse(response: TrendsResponse): void {
        this.tableHolder = {...this.tableHolder, response, cachedTime: dayjs()};
    }

    getState(): TrendsTableInfo {
        return this.tableHolder;
    }

    clear(): void {
        this.tableHolder = this.initialState();
    }

    private initialState(): TrendsTableInfo {
        return <TrendsTableInfo>{
            tableEvent: {
                ...initialTableEvent,
                filter: {},
            },
        };
    }
}

export interface TrendsTableInfo {
    tableEvent: TableEvent;
    response?: TrendsResponse;
    cachedTime: dayjs.Dayjs;
}
